import React, { useState } from 'react';
import Header from '../components/header';
import Footer from '../components/footer';

export default function AddProduct() {
  return (
    <>
      <Header />
      <section className="breadcrumb">
        <div className="container">
          <ul>
            <li><a href="/">Home</a></li>
            <li>Add Product</li>
          </ul>
        </div>
      </section>
      <section className="dashboard">
        <div className="container">
          <div className="row">
            <aside className="col-md-3 shadow p-4">
              <strong className="fs_16">Products</strong>
              <div className="box my-3 border-bottom py-2 border-top">
                <a className="collapse_btn" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
                  <strong className="fs_14 mb-2 d-block ps-2">All Products</strong>
                </a>
                <div className="list ps-2 collapse" id='collapseExample'>
                  <div className="check mb-2 d-flex align-items-center">
                    <a href='#' className="ms-1 fs_13 fw_500"><svg class="me-2" xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24"><path fill="none" stroke="grey" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M6.25 10.5a4.25 4.25 0 1 0 0-8.5a4.25 4.25 0 0 0 0 8.5M17.75 22a4.25 4.25 0 1 0 0-8.5a4.25 4.25 0 0 0 0 8.5m-11.5 0a4.25 4.25 0 1 0 0-8.5a4.25 4.25 0 0 0 0 8.5M20.868 2.439l.692.692a1.5 1.5 0 0 1 0 2.122l-3.627 3.695a2 2 0 0 1-1.047.552l-2.248.488a.5.5 0 0 1-.595-.593l.478-2.236a2 2 0 0 1 .552-1.047l3.674-3.673a1.5 1.5 0 0 1 2.12 0" color="grey"></path></svg>Dashboard</a>
                  </div>
                  <div className="check mb-2 d-flex align-items-center">
                    <a href='#' className="ms-1 fs_13 fw_500"><svg className="me-2" xmlns="http://www.w3.org/2000/svg" width="1.3em" height="1.3em" viewBox="0 0 24 24"><path fill="currentColor" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10s10-4.477 10-10S17.523 2 12 2m5 11h-4v4h-2v-4H7v-2h4V7h2v4h4z" /></svg>Add Products</a>
                  </div>
                </div>
              </div>
            </aside>
            <div className="col-md-9">
              <div className="row ps-md-3">
                <div className="list border rounded py-1 px-2 mb-4">
                  <div className="row align-items-center">
                    <div className="col-md-7">
                      <div className="d-flex align-items-center gap-3">
                        <div className="pro_img"><img src="../../electronics/mobile/redmi-c67e.jpeg" alt="" title='' /></div>
                        <div className="title ellipse line_3 fs_13">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptatum ab nihil dolorum iusto ex saepe, nisi, doloremque velit nostrum, beatae consectetur qui id consequuntur assumenda vero inventore. Ipsam, tempore saepe!</div>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="price-col d-flex flex-wrap fs_12 gap-2">
                        <div className="price_first text-decoration-line-through text-muted">₹5000</div>
                        <div className="price_end">₹2500</div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="d-flex align-items-center gap-3">
                        <a href='#' className="edit"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20"><path fill="#fff" d="M12.92 2.873a2.975 2.975 0 0 1 4.207 4.207l-.669.669l-4.207-4.207zM11.544 4.25l-7.999 7.999a2.44 2.44 0 0 0-.655 1.194l-.878 3.95a.5.5 0 0 0 .597.597l3.926-.873a2.5 2.5 0 0 0 1.234-.678l7.982-7.982z" /></svg> Add</a>
                        <a href='#' className="remove">
                          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="#fff" fillRule="evenodd" d="M5.75 3V1.5h4.5V3zm-1.5 0V1a1 1 0 0 1 1-1h5.5a1 1 0 0 1 1 1v2h2.5a.75.75 0 0 1 0 1.5h-.365l-.743 9.653A2 2 0 0 1 11.148 16H4.852a2 2 0 0 1-1.994-1.847L2.115 4.5H1.75a.75.75 0 0 1 0-1.5zm-.63 1.5h8.76l-.734 9.538a.5.5 0 0 1-.498.462H4.852a.5.5 0 0 1-.498-.462z" clipRule="evenodd" /></svg>
                          Remove</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="list border rounded py-1 px-2 mb-4">
                  <div className="row align-items-center">
                    <div className="col-md-7">
                      <div className="d-flex align-items-center gap-3">
                        <div className="pro_img"><img src="../../electronics/mobile/redmi-c67b.jpeg" alt="" title='' /></div>
                        <div className="title ellipse line_3 fs_13">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptatum ab nihil dolorum iusto ex saepe, nisi, doloremque velit nostrum, beatae consectetur qui id consequuntur assumenda vero inventore. Ipsam, tempore saepe!</div>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="price-col d-flex flex-wrap fs_12 gap-2">
                        <div className="price_first text-decoration-line-through text-muted">₹5000</div>
                        <div className="price_end">₹2500</div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="d-flex align-items-center gap-3">
                        <a href='#' className="edit"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20"><path fill="#fff" d="M12.92 2.873a2.975 2.975 0 0 1 4.207 4.207l-.669.669l-4.207-4.207zM11.544 4.25l-7.999 7.999a2.44 2.44 0 0 0-.655 1.194l-.878 3.95a.5.5 0 0 0 .597.597l3.926-.873a2.5 2.5 0 0 0 1.234-.678l7.982-7.982z" /></svg> Add</a>
                        <a href='#' className="remove">
                          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="#fff" fillRule="evenodd" d="M5.75 3V1.5h4.5V3zm-1.5 0V1a1 1 0 0 1 1-1h5.5a1 1 0 0 1 1 1v2h2.5a.75.75 0 0 1 0 1.5h-.365l-.743 9.653A2 2 0 0 1 11.148 16H4.852a2 2 0 0 1-1.994-1.847L2.115 4.5H1.75a.75.75 0 0 1 0-1.5zm-.63 1.5h8.76l-.734 9.538a.5.5 0 0 1-.498.462H4.852a.5.5 0 0 1-.498-.462z" clipRule="evenodd" /></svg>
                          Remove</a>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="list border rounded py-1 px-2 mb-4">
                  <div className="row align-items-center">
                    <div className="col-md-7">
                      <div className="d-flex align-items-center gap-3">
                        <div className="pro_img"><img src="../../electronics/mobile/redmi-c67c.jpeg" alt="" title='' /></div>
                        <div className="title ellipse line_3 fs_13">Lorem, ipsum dolor sit amet consectetur adipisicing elit. Voluptatum ab nihil dolorum iusto ex saepe, nisi, doloremque velit nostrum, beatae consectetur qui id consequuntur assumenda vero inventore. Ipsam, tempore saepe!</div>
                      </div>
                    </div>
                    <div className="col-md-2">
                      <div className="price-col d-flex flex-wrap fs_12 gap-2">
                        <div className="price_first text-decoration-line-through text-muted">₹5000</div>
                        <div className="price_end">₹2500</div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <div className="d-flex align-items-center gap-3">
                        <a href='#' className="edit"><svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 20 20"><path fill="#fff" d="M12.92 2.873a2.975 2.975 0 0 1 4.207 4.207l-.669.669l-4.207-4.207zM11.544 4.25l-7.999 7.999a2.44 2.44 0 0 0-.655 1.194l-.878 3.95a.5.5 0 0 0 .597.597l3.926-.873a2.5 2.5 0 0 0 1.234-.678l7.982-7.982z" /></svg> Add</a>
                        <a href='#' className="remove">
                          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 16 16"><path fill="#fff" fillRule="evenodd" d="M5.75 3V1.5h4.5V3zm-1.5 0V1a1 1 0 0 1 1-1h5.5a1 1 0 0 1 1 1v2h2.5a.75.75 0 0 1 0 1.5h-.365l-.743 9.653A2 2 0 0 1 11.148 16H4.852a2 2 0 0 1-1.994-1.847L2.115 4.5H1.75a.75.75 0 0 1 0-1.5zm-.63 1.5h8.76l-.734 9.538a.5.5 0 0 1-.498.462H4.852a.5.5 0 0 1-.498-.462z" clipRule="evenodd" /></svg>
                          Remove</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}
